import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const monthEndProcessAPI = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    getAttendanceRegularization: builder.query({
      query: ({ month, empId, sortDirection, page, size, search }) =>
        ({url: API_ENDPOINTS.MONTHENDPROCESS.GET_ATTENDANCE_REGULARIZATION(
          month,
          empId,
          sortDirection,
          page,
          size,
          search
        )}),
        providesTags: (result) =>
          result && Array.isArray(result)
            ? [{ type: "AttendanceRegularization", id: "LIST" }]
            : [{ type: "AttendanceRegularization", id: "LIST" }],
    }),
    getLeaveApplication: builder.query({
      query: ({ leaveType, empId,month, sortDirection, page, size, search }) =>
        ({url: API_ENDPOINTS.MONTHENDPROCESS.GET_LEAVE_APPLICATION(
          leaveType,
          empId,
          month,
          sortDirection,
          page,
          size,
          search
        )}),
        providesTags: (result) =>
          result && Array.isArray(result)
            ? [{ type: "LeaveApplication", id: "LIST" }]
            : [{ type: "LeaveApplication", id: "LIST" }],
    }),
    addAttendanceRegularization: builder.mutation({
      query: ({ formData }) => ({
        url: API_ENDPOINTS.MONTHENDPROCESS.ADD_ATTENDANCE_REGULARIZATION(),
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "AttendanceRegularization", id: "LIST" }],
    }),
    addAttendanceLeaveApproval: builder.mutation({
      query: ({ formData }) => ({
        url: API_ENDPOINTS.MONTHENDPROCESS.ADD_ATTENDANCE_LEAVE_APPROVAL(),
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "LeaveApplication", id: "LIST" }],
    }),
  }),
});

export const { useGetAttendanceRegularizationQuery, useAddAttendanceRegularizationMutation , useGetLeaveApplicationQuery, useAddAttendanceLeaveApprovalMutation } = monthEndProcessAPI;
